import { render, staticRenderFns } from "./ParticipantesComponent.vue?vue&type=template&id=490cd7c0&scoped=true"
import script from "./ParticipantesComponent.vue?vue&type=script&lang=js"
export * from "./ParticipantesComponent.vue?vue&type=script&lang=js"
import style0 from "./ParticipantesComponent.vue?vue&type=style&index=0&id=490cd7c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490cd7c0",
  null
  
)

export default component.exports